import React, { useState } from 'react';
import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Typography,
  patientAccessTheme,
} from '@HomaHealth/ui-component-library';
import {
  Button,
  RadioButton,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import componentConstants from '../../../core-utils/messages/componentConstants';

export interface DownloadReportModalProps {
  open: boolean;
  handleClose: () => any;
  handleDownload: () => any;
  options: any[];
  setOptions: React.Dispatch<React.SetStateAction<any[]>>;
  subTitle?: string;
  title?: string;
}

const DownloadReportModal: React.FC<DownloadReportModalProps> = ({
  open,
  handleClose,
  handleDownload,
  title,
  subTitle,
  options,
  setOptions,
}) => {
  const useStyles = makeStyles()({
    root: {
      width: '700px',
      backgroundColor: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 32px',
      position: 'absolute',
      left: 'calc((100vw - 804px)/2)',
      top: 'calc((100vh - 358px)/2)',
      flexDirection: 'column',
    },
    button: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });

  const { classes } = useStyles();
  const messages = componentConstants.PAGES.REPORTS;
  const [rowIndex, setRowIndex] = useState<number | undefined>(undefined);

  const handleRowSelect = (index: number) => {
    const localGroupRows: any = options.map((item) => ({
      ...item,
      checked: false,
    }));
    localGroupRows[index].checked = !localGroupRows[index].checked;
    setOptions(localGroupRows);
    setRowIndex(localGroupRows[index].checked ? index : undefined);
  };

  return (
    <Modal style={{ zIndex: 500 }} open={open} onClose={handleClose}>
      <Grid container className={classes.root}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="0px 0px 4px 0px"
          >
            {title}
          </Typography>
        </Grid>
        <Grid>
          <Typography
            fontSize="14px"
            lineHeight="25px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {subTitle}
          </Typography>
        </Grid>
        <Grid
          style={{
            margin: '24px 0px',
          }}
        >
          {options?.map((item, index) => (
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '0px 24px 0px 0px',
              }}
            >
              <RadioButton
                color={patientAccessTheme.palette.primary[400]}
                checked={item.checked || false}
                handleChange={() => handleRowSelect(index)}
              />
              <Grid>
                <Typography
                  fontSize="12px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                >
                  {item.report}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={messages.MODAL.CANCEL}
              variant="outlined"
              className={classes.button}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={messages.MODAL.DOWNLOAD}
              variant="contained"
              disabled={rowIndex === undefined}
              className={classes.button}
              onClick={handleDownload}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default DownloadReportModal;
